// extracted by mini-css-extract-plugin
export var currencyInput = "_k2-1";
export var currencySymbol = "_k2-0";